import styled, { keyframes } from "styled-components";
import {
  AppBar as MuiAppBar,
  Button as MuiButton,
  IconButton as MuiIconButton,
  Toolbar as MuiToolbar
} from "@material-ui/core";

export const AppBar = styled(MuiAppBar)`
  background: ${props => props.theme.header.background};
  color: ${props => props.theme.header.color};
`;

export const Toolbar = styled(MuiToolbar)`
  position: relative;
  padding: ${props => props.theme.heightRatio*props.theme.spacing(5.25)}px
           ${props => props.theme.widthRatio*props.theme.spacing(12.5)}px;
  min-height: ${props => props.theme.heightRatio*110}px;
`;

export const ToParent = styled(MuiButton)`
  color: inherit;
  font: ${props => props.theme.widthRatio*24}px/${props => props.theme.heightRatio*32}px SFProRounded-Regular;
  border-radius: ${props => props.theme.widthRatio*5}px;
  text-decoration: unset;
  padding: ${props => props.theme.heightRatio*props.theme.spacing(2.5)}px
           ${props => props.theme.widthRatio*props.theme.spacing(5.5)}px;
  margin-left: -${props => props.theme.widthRatio*props.theme.spacing(5)}px;
  
  &:hover {
    background: ${props => props.theme.palette.third["10"]};
  }
  
  span {
    color: inherit;
    font: inherit;
  
    &::first-letter {
      text-transform: uppercase;
    }
  }
  
  svg {
  	width: ${props => props.theme.widthRatio*24}px;
  	height: ${props => props.theme.widthRatio*24}px;
  }
`;

export const Button = styled(MuiButton)`
  background: ${props => props.theme.palette.primary["750"]};
  border: none;
  padding: ${props => props.theme.heightRatio*props.theme.spacing(3)}px
           ${props => props.theme.widthRatio*props.theme.spacing(3.5)}px;
           
  &.active {
    background: ${props => props.theme.palette.primary["900"]};
  }
  
  img {
    width: ${props => props.theme.widthRatio*22}px;
    height: ${props => props.theme.heightRatio*22}px;
  }
`;

export const IconButtonGroup = styled.div`
  margin-right: ${props => props.theme.widthRatio*40}px;
`;

const rollKeyFrame = keyframes`
  0% {
    transform: rotate(0);
  }
  20% {
    transform: rotate(72deg);
  }
  40% {
    transform: rotate(144deg);
  }
  60% {
    transform: rotate(216deg);
  }
  80% {
    transform: rotate(288deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const IconButton = styled(MuiIconButton)`
  width: ${props => props.theme.widthRatio*42}px;
  height: ${props => props.theme.widthRatio*42}px;
  min-width: unset;
  padding: 0;
  margin-right: ${props => props.theme.widthRatio*15}px;
  
  &:hover {
    background: ${props => props.theme.palette.third["10"]};
  }
  
  svg {
    stroke: ${props => props.theme.palette.third["100"]};
    fill: ${props => props.theme.palette.third["100"]};
  }
  
  &.refresh-btn {
    &.true {
      animation: ${rollKeyFrame} 0.5s ease-out;
      animation-iteration-count: infinite;
    }
  }
`;
